import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OfferCoverageDestinyLabel } from '../../core/models/offer/offer-coverage-destiny-label.model';
import { OfferCoverageDestinyOptionValues } from '../../core/models/offer/offer-coverage-destiny-option-values.model';

@Injectable()
export class LanguageService {

  constructor(public translateService: TranslateService) {
    this.translateService.setDefaultLang('pl');
  }

  setLanguage(lang: string): void {
    this.translateService.use(lang);
  }

  getDefaultLanguage(): string {
    return this.translateService.getDefaultLang();
  }

  setDefaultLanguage(lang: string = 'PL') {
    this.translateService.setDefaultLang(lang.toLowerCase());
  }

  getTranslationForKey(labels: TranslationItem[] | any[], key: string): string | null {
    const defaultLang = this.getDefaultLanguage();
    return <string | null>this.getKeyTranslation(labels, defaultLang, key);
  }

  getLabel(labels: TranslationItem[]): string | null {
    const defaultLang = this.getDefaultLanguage();
    return <string | null>this.getKeyTranslation(labels, defaultLang, 'label');
  }

  getDescription(labels: TranslationItem[]): string | null {
    const defaultLang = this.getDefaultLanguage();
    return <string | null>this.getKeyTranslation(labels, defaultLang, 'description');
  }

  getTooltip(labels: TranslationItem[]): string | null {
    const defaultLang = this.getDefaultLanguage();
    return <string | null>this.getKeyTranslation(labels, defaultLang, 'tooltip');
  }

  getBooleanOption(options: TranslationItem[]): boolean | null {
    const defaultLang = this.getDefaultLanguage();
    return <boolean | null>this.getKeyTranslation(options, defaultLang, 'value');
  }

  private getKeyTranslation(labels: TranslationItem[], lang: string, key: string): string | boolean | null {
    try {
      return this.filterArrayByCurrentLang(labels, lang)[0][key];
    } catch {
      return null;
    }
  }

  private filterArrayByCurrentLang(param: any[] | OfferCoverageDestinyLabel[] | OfferCoverageDestinyOptionValues[], lang: string): any[] | OfferCoverageDestinyLabel[] | OfferCoverageDestinyOptionValues[] {
    return param.filter(({ languageCode }) => languageCode === lang.toUpperCase());
  }

}

export class TranslationItem {
  languageCode: string;

  [key: string]: string | boolean | number;
}
